/**
 * Web-only Health icon: white rounded square with dark green heart in top-right.
 * Matches native HealthIconSquare (12px radius, cedarDark heart) for parity across Android/iOS/web.
 */

import React from 'react';

const CORNER_RADIUS = 12;
const CEDAR_DARK = '#113C2B';
const HEART_PATH =
  'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';

export function HealthIconSquareWeb({
  size = 56,
  heartSize = 24,
  className = '',
  style = {},
  transparentBackground = false,
  variant = 'default', // 'light' = white heart for dark/teal backgrounds
}: {
  size?: number;
  heartSize?: number;
  className?: string;
  style?: React.CSSProperties;
  transparentBackground?: boolean;
  variant?: 'default' | 'light';
}) {
  const padding = size * 0.12;
  const heartFill = variant === 'light' ? '#ffffff' : CEDAR_DARK;

  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: CORNER_RADIUS,
        backgroundColor: transparentBackground ? 'transparent' : '#FFFFFF',
        overflow: 'hidden',
        position: 'relative',
        flexShrink: 0,
        ...style,
      }}
      aria-hidden="true"
    >
      <svg
        width={heartSize}
        height={heartSize}
        viewBox="0 0 24 24"
        fill="none"
        style={{
          position: 'absolute',
          top: padding,
          right: padding,
        }}
      >
        <path d={HEART_PATH} fill={heartFill} />
      </svg>
    </div>
  );
}
